"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAdminEndpoints = createAdminEndpoints;
/**
 * PANEL İŞ UÇLARI — hepsi `/panel/*` altındadır (panel kimliği ayrımı · S2).
 *
 * Alan grubunun ADI (`admin`) korundu: `apps/admin` sagaları `api.admin.*`
 * çağırıyor ve yeniden adlandırma 30+ çağrıyı dokunuşsuz bir gürültüye
 * çevirirdi. Değişen şey YOL: `/admin/...` → `/panel/...`, yani istek artık
 * personel guard zincirine düşer ve ürün jetonu 401 alır.
 *
 * Sahiplenme KARARLARI da buradadır (`claims`): ürün tarafındaki okuma uçları
 * (`/claims/mine`, `/claims/incoming`) `endpoints/events.ts` ailesinde DEĞİL,
 * hiçbir yerde — panel dışı sahiplenme yüzeyi Blok 8-1'de kapandı.
 */
function createAdminEndpoints(client) {
    return {
        admin: {
            users: (query) => client.call('/panel/users', 'get', { query: query }),
            suspendUser: (userId, input) => client.call('/panel/users/{id}/suspend', 'post', { path: { id: userId }, body: input }),
            unsuspendUser: (userId, input) => client.call('/panel/users/{id}/unsuspend', 'post', { path: { id: userId }, body: input }),
            /** Kurum doğrulama kuyruğu (Story 18.4) — rol kapısı sunucudadır. */
            organizationVerifications: (query) => client.call('/panel/organization-verifications', 'get', { query: query }),
            /** İmzalı ve süreli belge bağlantısı — her üretimi denetim kaydına yazılır. */
            organizationVerificationDocument: (requestId) => client.call('/panel/organization-verifications/{id}/document', 'get', {
                path: { id: requestId },
            }),
            decideOrganizationVerification: (requestId, input) => client.call('/panel/organization-verifications/{id}/decision', 'post', {
                path: { id: requestId },
                body: input,
            }),
            moderationQueue: (query) => client.call('/panel/moderation/queue', 'get', { query: query }),
            moderationItem: (itemId) => client.call('/panel/moderation/queue/{id}', 'get', { path: { id: itemId } }),
            decideModeration: (itemId, input) => client.call('/panel/moderation/queue/{id}/decide', 'post', {
                path: { id: itemId },
                body: input,
            }),
            runSignals: () => client.call('/panel/moderation/signals/run', 'post', {}),
            overview: () => client.call('/panel/overview', 'get', {}),
            /*
             * GENEL GÖRÜNÜM PANOSU (kullanıcı kararı 2026-09-02 §3). Dördü de
             * OKUMADIR; katılımcı dökümü sunucuda denetim kaydı düşürür.
             */
            statsOverview: () => client.call('/panel/stats/overview', 'get', {}),
            statsEventsByCity: () => client.call('/panel/stats/events-by-city', 'get', {}),
            statsEvents: (query) => client.call('/panel/stats/events', 'get', { query: query }),
            /**
             * E-POSTA GÖNDERİM GÖRÜNÜMÜ (panel · salt okunur). TEK sarmalayıcı: uçta
             * yeniden gönderme, dışa aktarma ya da gövde okuma FİİLİ YOKTUR.
             */
            emailDeliveries: (query) => client.call('/panel/email-deliveries', 'get', { query: query }),
            statsEventAttendees: (eventId, query) => client.call('/panel/stats/events/{id}/attendees', 'get', {
                path: { id: eventId },
                query: query,
            }),
        },
        /**
         * Sahiplenme. Blok 8-1'de KULLANICI YÜZEYİ kapatıldı: talep açma, kanıt ekleme,
         * incelemeye gönderme, geri çekme, itiraz, sahip onayı ve sahiplenilebilir
         * etkinlik araması sarmalayıcıları KALDIRILDI (sunucuda rota yok → 404).
         * Kalanlar: okuma + admin kararı.
         */
        claims: {
            /** Ürün tarafı okuma uçları — talebin TARAFI olan kullanıcı çağırır. */
            mine: () => client.call('/claims/mine', 'get', {}),
            incoming: () => client.call('/claims/incoming', 'get', {}),
            /*
             * PANEL YOLU (`/panel/claims/*`): personel kararı ve personel okuması.
             * Eski hâlinde üçü de `/claims/*` altındaydı ve görünüm rolü
             * `users.role`ten türüyordu — o türetme S3'te kalktı.
             */
            get: (claimId) => client.call('/panel/claims/{id}', 'get', { path: { id: claimId } }),
            decide: (claimId, input) => client.call('/panel/claims/{id}/decide', 'post', { path: { id: claimId }, body: input }),
            requestInfo: (claimId, input) => client.call('/panel/claims/{id}/request-info', 'post', {
                path: { id: claimId },
                body: input,
            }),
        },
    };
}
//# sourceMappingURL=admin.js.map